import {createAction, props} from '@ngrx/store';
import {LesgroepInformatieRegel, TotaalInformatieRegel} from './vakdashboard.state';
import {Payload} from '../payload';

export const setVakdashboard = createAction('[Vakdashboard] Set vakdashboard', props<{ onderwijssoort: string, vak: string, regels: LesgroepInformatieRegel[], totaalRij: TotaalInformatieRegel }>());
export const fetchDocenten = createAction('[Vakdashboard] Fetch docentnamen');
export const setDocenten = createAction('[Vakdashboard] Set docentnamen', props<Payload<{uuid: string, naam: string }[]>>());
export const resetVakdashboard = createAction('[Vakdashboard] Reset vakdashboard');
